// extracted by mini-css-extract-plugin
export var center = "_4u-2";
export var clickableRow = "_4u-5";
export var expandedRow = "_4u-7";
export var hoverable = "_4u-4";
export var left = "_4u-1";
export var right = "_4u-3";
export var row = "_4u-0";
export var selectedRow = "_4u-6";
export var summaryRow = "_4u-8";